import React from "react"

export const withArticleBreadcrumb = Component => ({ name = "ArticleBreadcrumb", category, locales, screen = null, title }) => {
  const breadcrumbs = [{ title: locales?.title }, { title: category?.title }, { title: title }]

  Component.displayName = name
  return <Component breadcrumbs={breadcrumbs} screen={screen} />
}
